import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from '../constants';
import * as D from '../deps';

export const BackstageHeaderPlayPauseButton = props => {
  const { theme, isInline, isPillShaped, isDisabled, looksDisabled, iconType, onClick, qaTag } =
    props;

  return (
    <D.ButtonT3
      theme={theme}
      isInline={isInline}
      isPillShaped={isPillShaped}
      isDisabled={isDisabled}
      looksDisabled={looksDisabled}
      iconType={iconType}
      onClick={onClick}
      qaTag={qaTag}
    >
      <FormattedMessage {...messages.topSongs} />
    </D.ButtonT3>
  );
};

BackstageHeaderPlayPauseButton.defaultProps = {
  theme: D.ButtonT3Theme.LIGHT,
  isInline: false,
  isPillShaped: false,
  qaTag: D.QA.BSATS,
};

BackstageHeaderPlayPauseButton.propTypes = {
  theme: PropTypes.string,
  isInline: PropTypes.bool,
  isPillShaped: PropTypes.bool,
  isDisabled: PropTypes.bool,
  looksDisabled: PropTypes.bool,
  iconType: PropTypes.string,
  onClick: PropTypes.bool,
  qaTag: PropTypes.string,
};

export default BackstageHeaderPlayPauseButton;
